<template>
  <div class="house-card" @click="detail">
    <div class="img">
      <img :src="item.fileImg" alt="" />
      <img v-if="item.panorama" src="https://static.ajl.cn/web/360.png" alt="" class="panorama" />
    </div>
    <div class="area">
      <span class="area-label">{{ $cov(item.area || item.roomArea).num }}</span>
      <span class="area-unit">㎡</span>
    </div>
    <div class="person" v-if="root.name === 'office'">
      <span>{{ people }}</span>
      <span class="person-unit">人</span>
    </div>
    <div class="orientation">{{ item.orientationName }}</div>
    <div class="price" v-if="type === 'room'">
      <span>{{ $cov(item.rentPrice).num }}</span>
      <span class="price-unit">{{ $cov(item.rentPrice).unit }}</span>
    </div>
    <div class="price" v-else>{{ priceType === 1 ? item.averagePrice : item.consultPrice }}</div>
    <div class="update">{{ item.releaseTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'house-card',
  props: { item: Object, priceType: Number, type: String },
  computed: {
    people() {
      if (parseFloat(this.item.roomArea) % 4 === 0) return parseFloat(this.item.roomArea) / 4 + '-' + (parseFloat(this.item.roomArea) / 4 + parseFloat(1));
      return Math.floor(parseFloat(this.item.roomArea) / 4) + '-' + Math.ceil(parseFloat(this.item.roomArea) / 4);
    },
  },
  methods: {
    detail() {
      let name = this.root.name + '.first-detail';
      if (this.type === 'room') name = this.root.name + '.room-detail';
      this.$router.push({ name, query: { id: this.item.id, from: this.$route.query.from } });
    },
  },
};
</script>

<style lang="scss" scoped>
.house-card {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 40px 2fr 40px;
  padding: 10px 0;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
  .img {
    height: 60px;
    position: relative;
    img {
      width: 96px;
      height: 100%;
      border-radius: 6px;
      margin: 0 auto;
    }
    .panorama {
      width: 15px;
      height: 15px;
      position: absolute;
      left: 15px;
      bottom: 5px;
      animation-name: ani;
      animation-duration: 2.6s;
      animation-iteration-count: infinite;
    }
  }
  .area {
    display: flex;
    align-items: center;
    justify-content: center;
    &-label {
      font-size: 20px;
      margin-right: 4px;
    }
    &-unit {
      font-size: 12px;
    }
  }
  .price {
    font-size: 20px;
    color: #cc2929;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: block;
    }
    &-unit {
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .person {
    font-size: 16px;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    &-unit {
      font-size: 12px;
    }
  }
  .orientation {
    font-size: 12px;
    color: #000;
  }
  .update {
    font-size: 12px;
    color: #b2b2b2;
  }
}
@keyframes ani {
  70% {
    transform: rotate(360deg) scale(1.2);
  }
  100% {
    transform: rotate(360deg) scale(1.2);
  }
}
</style>
